module.exports = __webpack_public_path__ + "static/example-290a114bc85b5ab63404195c76981cf3.png";